var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4956 7.66713H4.83834M7.66699 4.83847V10.4958M12.3814 12.3815C9.77771 14.9853 5.55627 14.9853 2.95257 12.3815C0.348866 9.77784 0.348866 5.55641 2.95257 2.9527C5.55627 0.349 9.77771 0.349 12.3814 2.9527C14.9851 5.55641 14.9851 9.77784 12.3814 12.3815Z",
    stroke: "#8F333B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyShape);
export default __webpack_public_path__ + "static/media/body-shape.66a5efe6167d4e22c87e11ec0d548da0.svg";
export { ForwardRef as ReactComponent };